import { get } from "../../utils/object-helpers";
$ {
    const profileEditState = get(input, 'globalState.profileEdit', null);
    const confirmationModal = get(input, 'confirmationModal', null);
}

<div class="str-seller-card" key="str-seller-card">
    <div class="str-seller-card__store-logo">
        <str-header-logo ...input.headerLogoInput page=input.page />
    </div>
    <div class="str-seller-card__store-name">
        <h1>
            <a href=input.name.link data-track=input.name.tracking>
                <str-text-span textSpans=input.name.text />
            </a>
        </h1>
    </div>
    <if(profileEditState?.editing && input.editProfileDescriptions.editProfileDescriptionsLine1)>
        <div class="str-seller-card__edit-profile-description">
            <div class="str-seller-card__edit-profile-description_line1">
                ${input.editProfileDescriptions.editProfileDescriptionsLine1}
            </div>
            <if(input.editProfileDescriptions.editProfileDescriptionsLine2)>
                <ebay-fake-link
                    class="str-seller-card__edit-profile-description_line2"
                    disabled=false
                    data-track=input.editProfileDescriptions.tracking
                    on-click('openDialog', confirmationModal.saveAction.url)>
                    ${input.editProfileDescriptions.editProfileDescriptionsLine2}
                </ebay-fake-link>
                <ebay-lightbox-dialog
                    open=(confirmationModal.saveAndGoAction && confirmationModal.dismissAndGoAction && state.showConfirmDialog)
                    class="str-seller-card__edit-profile-lightbox-dialog"
                    button-position="hidden">
                    <@header>${confirmationModal.title}</@header>
                    <p>${confirmationModal.subTitle}</p>
                    <@footer>
                        <ebay-button
                            class='str-seller-card__edit-profile-dialog-cancel'
                            priority='secondary'
                            on-click('navigateWithoutSaving', confirmationModal.dismissAndGoAction.action, confirmationModal.dismissAction.url)>
                            ${confirmationModal.dismissAction.text}
                        </ebay-button>
                        <ebay-button
                            class='str-seller-card__edit-profile-dialog-save'
                            disabled=profileEditState?.saveAndGo
                            priority='primary'
                            on-click('saveAndNavigate', confirmationModal.saveAndGoAction.action, confirmationModal.saveAction.url)>
                            <if(!profileEditState?.saveAndGo)>
                                ${confirmationModal.saveAction.text}
                            </if>
                            <else>
                                <ebay-progress-spinner size="small" aria-live="polite" />
                            </else>
                        </ebay-button>
                    </@footer>
                </ebay-lightbox-dialog>
            </if>
        </div>
    </if>
    <if (!profileEditState?.editing)>
        <div class="str-seller-card__stats">
            <div class="str-seller-card__stats-content">
                <if(input.feedback.textString)>
                    <div title=input.feedback.textString>
                        <if(input.feedback.link)>
                            <a class="str-seller-card__feedback-link" href=input.feedback.link data-track=input.feedback.tracking>
                                <str-text-span textSpans=input.feedback.textSpans/>
                            </a>
                        </if>
                        <else>
                            <str-text-span textSpans=input.feedback.textSpans/>
                        </else>
                    </div>
                </if>
                <if(input.sold.textString)>
                    <div title=input.sold.textString>
                        <str-text-span textSpans=input.sold.textSpans/>
                    </div>
                </if>
                <if(input.follow.textString)>
                    <div title=input.follow.textString>
                        <str-text-span textSpans=input.follow.textSpans/>
                    </div>
                </if>
            </div>
        </div>
    </if>
    <div class="str-seller-card__buttons">
        <div class="str-seller-card__buttons-content">
            <if(input.page.isSmall)>
                <if(input.isProfilePage && !input.isProfilePageEdit)>
                    <str-follow-button page=input.page />
                </if>
                <else-if(!input.isProfilePage)>
                    <str-follow-button page=input.page />
                    <str-overflow-button page=input.page />
                </else-if>
            </if>
            <else>
                <if(input.isProfilePageEdit)>
                    <str-profile-edit-buttons page=input.page globalState=input.globalState />
                </if>
                <else>
                    <str-share-button page=input.page />
                    <str-contact-link page=input.page />
                    <str-follow-button page=input.page />
                </else>
            </else>
        </div>
    </div>
    <if(input.isProfilePage && input.page.isSmall)>
        <div class="str-seller-card__footer">
            <if(input.isProfilePageEdit)>
                 <str-profile-edit-buttons
                    mobileView="edit"
                    page=input.page
                    globalState=input.globalState />
            </if>
            <else-if(input.contactSeller)>
                <ebay-button class="str-seller-card__contact-link" href=input.contactSeller.link priority="secondary">
                    ${input.contactSeller.text}
                </ebay-button>
            </else-if>
        </div>
    </if>
    <!--====================
    // Sentinals needed for the str-sticky-header and str-left-nav
    ========================-->
    <div class="str-seller-card__sticky-header-sentinel"></div>
    <div class="str-seller-card__sticky-left-nav-sentinel"></div>
</div>
